import {
  ActionDetails,
  ResourceDetails,
  ProjectCodeActionType,
} from '../common';

export enum KubernetesAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
  ENABLE_SCHEDULER = 'enable-schedule',
  DISABLE_SCHEDULER = 'disable-schedule',
  ADD_SCHEDULER = 'add-schedule',
  UPDATE_SCHEDULER = 'update-schedule',
  DELETE_SCHEDULER = 'delete-schedule',
}

export type KubernetesActionType =
  | KubernetesAction.START
  | KubernetesAction.STOP
  | KubernetesAction.RESTART
  | KubernetesAction.ENABLE_SCHEDULER
  | KubernetesAction.DISABLE_SCHEDULER
  | KubernetesAction.ADD_SCHEDULER
  | KubernetesAction.UPDATE_SCHEDULER
  | KubernetesAction.DELETE_SCHEDULER;

export type KubernetesResourceType = 'resources';

export interface CRDKubernetesConfig {
  provider?: 'kubernetes';
  kubeContext: string;
}

export interface KubernetesActionDetails extends ActionDetails {
  action: KubernetesActionType | ProjectCodeActionType;
  resourceType: KubernetesResourceType;
  kubeContext: string;
  scheduleKey?: string;
  scheduleValue?: string;
}

export enum KubernetesState {
  RUNNING = 'running',
  STOPPED = 'stopped',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface KubernetesResourceDetails extends ResourceDetails {
  kind: 'Deployment' | 'StatefulSet';
  status: KubernetesState;
  namespace: string;
  replicas: number;
  ready: number;
  previousDesiredSize?: number;
}

export interface KubernetesNamespaceDetails extends ResourceDetails {
  annotations: { [key: string]: string };
  labels: { [key: string]: string };
  creationTimestamp?: string;
  status: string;
}

export type KubernetesResourceDetailsType = KubernetesResourceDetails;
export type KubernetesNamespaceDetailsType = KubernetesNamespaceDetails;
